import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GetTranslationDto } from '@models/translation';
import { ApiService } from '@core/services/api/api.service';
import { environment } from '@env/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private url: string = `${environment.apiRoute}/translations`;

  constructor(private apiService: ApiService) {}

  private languages$: BehaviorSubject<GetTranslationDto[]> =
    new BehaviorSubject([]);
  private activeLanguage$: BehaviorSubject<GetTranslationDto> =
    new BehaviorSubject(new GetTranslationDto());

  get activeLanguageAsObs$(): Observable<GetTranslationDto> {
    return this.activeLanguage$.asObservable();
  }

  get activeLanguage(): GetTranslationDto {
    return this.activeLanguage$.getValue();
  }

  set activeLanguage(language: GetTranslationDto) {
    this.activeLanguage$.next(language);
  }

  get languages(): GetTranslationDto[] {
    return this.languages$.getValue();
  }

  getLanguages$(): Observable<GetTranslationDto[]> {
    return this.languages$.asObservable();
  }

  changeLanguage(language: string) {}

  getBlockTranslation(language: string, blockId: number) {}

  getAvailableLanguages(): Observable<GetTranslationDto[]> {
    return this.apiService.get<GetTranslationDto[]>(this.url).pipe(
      map((result: GetTranslationDto[]) => {
        this.languages$.next(result);
        return result;
      }),
    );
  }
}
